import { url } from '@exodus/fetch/url';
import { byArguments as makeConcurrentByArgs } from 'make-concurrent';
import { DEFAULT_BASE_URL } from './constants.js';
import { createUnitType } from './utils.js';
class AssetsService {
    #baseUrl;
    #fetchival;
    #appName;
    #currencyProvider;
    #cachedAssets = new Map();
    #cachedAssetsByNetwork = new Map();
    constructor({ baseUrl = DEFAULT_BASE_URL, fetchival, appName, currencyProvider, }) {
        this.#baseUrl = new URL(baseUrl);
        this.#fetchival = fetchival;
        this.#appName = appName;
        this.#currencyProvider = currencyProvider;
    }
    #getCurrency(assetId, decimals) {
        if (this.#currencyProvider) {
            try {
                const currency = this.#currencyProvider.getCurrency(assetId, decimals);
                if (currency) {
                    return currency;
                }
            }
            catch (error) {
                console.warn(`Failed to get currency from provider for asset ${assetId}:`, error);
            }
        }
        return createUnitType(assetId, decimals);
    }
    getOneById = makeConcurrentByArgs(async (id) => {
        if (this.#cachedAssets.has(id)) {
            return this.#cachedAssets.get(id) || null;
        }
        const networkWithAsset = [...this.#cachedAssetsByNetwork.values()].find((networkAssets) => networkAssets.has(id));
        if (networkWithAsset) {
            return networkWithAsset.get(id) || null;
        }
        const asset = await this.#fetchival(url `${this.#baseUrl}/assets/${id}`).get();
        asset.currency = this.#getCurrency(asset.id, asset.decimals);
        this.#cachedAssets.set(id, asset || null);
        return asset;
    });
    getAssetSources = async (sources, ids, direction) => {
        try {
            return await this.#fetchival(url `${this.#baseUrl}/asset-sources`, {
                headers: {
                    ...(this.#appName ? { 'App-Name': this.#appName } : {}),
                },
            }).get({
                sources: sources.join(','),
                assetIds: ids.join(','),
                groupBy: 'sources',
                ...(direction && { direction }),
            });
        }
        catch (err) {
            console.log(err);
        }
        return [];
    };
    async getPairs() {
        return this.#fetchival(url `${this.#baseUrl}/pairs`, {
            headers: {
                ...(this.#appName ? { 'App-Name': this.#appName } : {}),
            },
        }).get();
    }
}
export default AssetsService;
